import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {getLocalDate} from '@/common/helpers/date/getLocalDate';
import styles from './WeatherDailyDate.css';

interface WeatherDailyDateProps {
	date: string;
}

export const WeatherDailyDate: FC<WeatherDailyDateProps> = props => {
	const {date} = props;

	const {language} = useLocalizer();

	const [weekday, day, month] = getLocalDate(date, language);

	return (
		<div className={styles.root}>
			<p>{weekday}</p>
			<p className={styles.day}>{day}</p>
			<p className={styles.month}>{month}</p>
		</div>
	);
};

WeatherDailyDate.displayName = 'WeatherDailyDate';
